import React from "react";
import PropTypes from "prop-types";
import { css } from "glamor";

import { Chip } from "@namroodinc/ni-ui";
import MMAFighter from "./MMAFighter.js";

import styles from "../styles.module.scss";

const StrikesByZone = (props) => {
  if (Object.keys(props.data).length === 0) {
    return null;
  }

  const linearOffset = [props.gender === "male" ? 17 : 20, 50];

  const statsColumnsStrikesByZoneRule = css({
    gridTemplateRows: `${linearOffset[0]}% ${
      linearOffset[1] - linearOffset[0]
    }% ${100 - linearOffset[1]}%`
  });

  return (
    <div className={styles.statsColumnsStrikesByZone}>
      <div className={styles.statsColumnsFighter} data-fighter="home">
        <MMAFighter
          brandColor={props.homeBrandColor}
          data={props.data.map((stat) => stat.data.home.percentageValue)}
          gender={props.gender}
          linearOffset={linearOffset}
          id="home"
        />
      </div>
      <div
        className={`${styles.statsColumnsStrikesByZone} ${statsColumnsStrikesByZoneRule}`}
      >
        {props.data.map((stat, index) => (
          <React.Fragment key={index}>
            <div className={styles.statsColumnsStrikesByZoneBorderRow}>
              <Chip
                label={stat?.data?.home[props.typeOfValue]}
                color={props.homeBrandColor}
                backgroundOpacityPreset={
                  stat?.data?.home.highestValue === "home" &&
                  props.typeOfValue === "notes"
                    ? "medium"
                    : "solid"
                }
                profiling={
                  stat?.data?.home.highestValue === "home" &&
                  props.typeOfValue === "notes"
                    ? "background"
                    : "borderless"
                }
              />
            </div>
            <div className={styles.statsColumnsStrikesByZoneBorderRow}>
              <span className={styles.statsDetails}>
                <span className={styles.statsDetailsLabel}>{stat.label}</span>
              </span>
            </div>
            <div className={styles.statsColumnsStrikesByZoneBorderRow}>
              <Chip
                label={stat?.data?.away[props.typeOfValue]}
                color={props.awayBrandColor}
                backgroundOpacityPreset={
                  stat?.data?.away.highestValue === "away" &&
                  props.typeOfValue === "notes"
                    ? "medium"
                    : "solid"
                }
                profiling={
                  stat?.data?.away.highestValue === "away" &&
                  props.typeOfValue === "notes"
                    ? "background"
                    : "borderless"
                }
              />
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className={styles.statsColumnsFighter} data-fighter="away">
        <MMAFighter
          brandColor={props.awayBrandColor}
          data={props.data.map((stat) => stat.data.away.percentageValue)}
          gender={props.gender}
          linearOffset={linearOffset}
          id="away"
        />
      </div>
    </div>
  );
};

StrikesByZone.propTypes = {
  awayBrandColor: PropTypes.string,
  gender: PropTypes.string,
  homeBrandColor: PropTypes.string,
  data: PropTypes.array,
  label: PropTypes.string,
  typeOfValue: PropTypes.string
};

StrikesByZone.defaultProps = {
  awayBrandColor: "#FF0000",
  gender: "male",
  homeBrandColor: "#0000FF",
  data: [],
  label: "",
  typeOfValue: "percentage"
};

export default StrikesByZone;
